export default function () {
  const lazyImages = document.querySelectorAll(
    'img[loading=lazy]',
  ) as NodeListOf<HTMLImageElement>

  lazyImages.forEach((el) => {
    if (el.complete) {
      el.classList.add('img-lazy-load--is-complete')
      el.classList.remove('img-lazy-load--is-loading')
    } else {
      el.classList.add('img-lazy-load--is-loading')
    }
    el.addEventListener('load', () => {
      el.classList.add('img-lazy-load--is-complete')
      el.classList.remove('img-lazy-load--is-loading')
    })
  })
}
